<template>
<v-tooltip bottom :disabled="!tooltip_text">

      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
            <v-icon :small="small" :color="color">{{icon_name}}</v-icon>
        </span>
      </template>
      <span>{{tooltip_text}}</span>
    </v-tooltip>
    <!--v-icon :small="small" :color="color">{{icon_name}}</v-icon-->
</template>

<script>
export default {
    props: {
        'status': {
            type: String,
            required: true
        }, 
        'small': {
            type: Boolean,
            required: false,
            default: false
        }, 
        'tooltip_text':{
            type: String,
            required: false,
            default: null
        },
        "icon_color": {
            type: String,
            required: false,
            default: null
        }
    },
    data() {
        return {
            color: 'action',
            icon_name: 'star'
        }
    },
    mounted(){
        this.updateIcon()
    },
    methods: {
        updateIcon() {
            this.color = 'action'
            switch (this.status) {
                case 'ok':
                    this.icon_name = 'thumb_up'
                    if(this.icon_color){
                        this.color = this.icon_color
                    } else {
                        this.color = 'success'
                    }
                    break;
                case 'ko':
                    this.icon_name = 'thumb_down'
                    this.color = 'error'
                    break;
                case 'alert':
                    this.icon_name = 'report'
                    this.color = 'error'
                    break;
                case 'expired':
                    this.icon_name = 'notifications_active'
                    this.color = 'error'
                    break;
                case 'done':
                    this.icon_name = 'check_circle'
                    this.color = 'success'
                    break
                case 'all_done':
                    this.icon_name = 'all_done'
                    this.color = 'success'
                    break
                case 'deleted':
                    this.name = 'cancel_presentation'
                    break
                case 'waiting_review':
                    this.icon_name = 'rate_review'
                    break
                case 'verified':
                    this.icon_name = 'verified'
                    break
                case 'doing':
                    this.icon_name = 'av_timer'
                    break
                case 'failed':
                    this.icon_name = 'error'
                    this.color = 'error'
                    break
                case 'warning':
                    this.icon_name = 'warning'
                    this.color = 'warning'
                    break
                case 'ready':
                    this.icon_name = 'check_circle'
                    this.color = 'success'
                    break
                case 'no_reports':
                    this.icon_name = 'adjust'
                    break
                case 'new':
                    this.icon_name = 'fiber_new'
                    break
                case 'working':
                    this.icon_name = 'av_timer'
                    break
                case 'closed':
                    this.icon_name = 'assignment_turned_in'
                    break
                case 'uncomplete':
                    this.icon_name = 'playlist_add'
                    break
                case 'missing':
                    this.icon_name = 'report_off'
                    this.color = "warning"
                    break
                case 'picture_as_pdf':
                    this.icon_name = "picture_as_pdf"
                    break
                case 'signed':
                    this.icon_name = 'verified'
                    break
                case 'reviewed':
                    this.icon_name = 'exit_to_app'
                    break
                case 'revising':
                    this.icon_name = 'warning'
                    break
            }
        }
    },
    watch: {
        status(){
            this.updateIcon()
        }
    }
}

</script>